/*! Copyright (c) Safe As Milk. All rights reserved. */
class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = null;
        this.content = null;
        this.boundOnFocusOut = this.onFocusOut.bind(this);
        this.boundOnToggle = this.onToggle.bind(this);
    }
    connectedCallback() {
        this.mainDetailsToggle = this.querySelector("details");
        const summary = this.mainDetailsToggle?.querySelector("summary");
        this.content = summary?.nextElementSibling || null;
        if (!this.mainDetailsToggle || !summary || !this.content) return;
        this.mainDetailsToggle.addEventListener("focusout", this.boundOnFocusOut);
        this.mainDetailsToggle.addEventListener("toggle", this.boundOnToggle);
    }
    disconnectedCallback() {
        if (!this.mainDetailsToggle) return;
        this.mainDetailsToggle.removeEventListener("focusout", this.boundOnFocusOut);
        this.mainDetailsToggle.removeEventListener("toggle", this.boundOnToggle);
    }
    onFocusOut() {
        setTimeout((() => {
            if (!this.contains(document.activeElement)) this.close();
        }));
    }
    onToggle() {
        if (!this.content || !this.mainDetailsToggle) return;
        if (!this.animations) this.animations = this.content.getAnimations();
        if (this.mainDetailsToggle.hasAttribute("open")) {
            this.animations.forEach((animation => animation.play()));
        } else {
            this.animations.forEach((animation => animation.cancel()));
        }
    }
    close() {
        if (!this.mainDetailsToggle) return;
        this.mainDetailsToggle.removeAttribute("open");
        this.mainDetailsToggle.querySelector("summary")?.setAttribute("aria-expanded", false);
    }
}

if (!customElements.get("details-disclosure")) customElements.define("details-disclosure", DetailsDisclosure);

export default DetailsDisclosure;
//# sourceMappingURL=details-disclosure.js.map
